import { apiCall } from "./Interceptor";

const CREATE_CAPACITY_CONSUMER = "/consumer/capacity/create";
const UPDATE_CAPACITY_CONSUMER = "/consumer/capacity/update";
const DELETE_CAPACITY_CONSUMER = "/consumer/capacity/delete";
const GET_CAPACITY_CONSUMER = "/consumer/capacity/get";
const GET_ALL_CAPACITY_CONSUMER = "/consumer/capacity/getAll";
const UPDATE_CAPACITY_STATUS = "/consumer/capacity/updateStatus";
const GET_CAPACITY_EDIT_HISTORY = "/consumer/capacity/getHistory";
const GET_ALL_CON_CAPACITY_FOR_TRADER = "/consumer/capacity/getAllForTrader";
const INIT_RA = "/consumer/capacity/transfer";

const createConsumerCapacity = async (data) => {
  const response = await apiCall.post(CREATE_CAPACITY_CONSUMER, data);
  return response;
};

const getConsumerCapacity = async (id) => {
  const response = await apiCall.get(GET_CAPACITY_CONSUMER, id);
  return response;
};

const getAllConsumerCapacity = async (data) => {
  const response = await apiCall.post(
    `${GET_ALL_CAPACITY_CONSUMER}?current=true`,
    data
  );
  return response;
};

const updateConsumerCapacity = async (id) => {
  const response = await apiCall.put(UPDATE_CAPACITY_CONSUMER, id);
  return response;
};

const deleteConsumerCapacity = async (id) => {
  const response = await apiCall.delete(DELETE_CAPACITY_CONSUMER, id);
  return response;
};

const updateCapacityStatus = async (data) => {
  const response = await apiCall.patch(UPDATE_CAPACITY_STATUS, data);
  return response;
};
const getCapacityEditHistoryConsumer = async (id) => {
  const response = await apiCall.get(`${GET_CAPACITY_EDIT_HISTORY}?id=${id}`);
  return response;
};

const getAllConCapacityForTrader = async (data) => {
  const response = await apiCall.post(GET_ALL_CON_CAPACITY_FOR_TRADER, data);
  return response;
};

const initRaDirectConsumer = async (id) => {
  const response = await apiCall.get(`${INIT_RA}?id=${id}`);
  return response;
};

export default {
  createConsumerCapacity,
  getConsumerCapacity,
  updateConsumerCapacity,
  deleteConsumerCapacity,
  getAllConsumerCapacity,
  updateCapacityStatus,
  getCapacityEditHistoryConsumer,
  getAllConCapacityForTrader,
  initRaDirectConsumer,
};
